import { ComponentProps } from "react";

export const SearchIcon = (props: ComponentProps<"svg">) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.5 11.5C16.5 14.8137 13.8137 17.5 10.5 17.5C7.18629 17.5 4.5 14.8137 4.5 11.5C4.5 8.18629 7.18629 5.5 10.5 5.5C13.8137 5.5 16.5 8.18629 16.5 11.5ZM18 11.5C18 15.6421 14.6421 19 10.5 19C6.35786 19 3 15.6421 3 11.5C3 7.35786 6.35786 4 10.5 4C14.6421 4 18 7.35786 18 11.5ZM19.0134 17.6543C18.6268 17.2704 18.0072 17.2704 17.6207 17.6543C17.4203 17.8561 17.3076 18.1304 17.3076 18.4164C17.3076 18.6615 17.3904 18.898 17.5403 19.0877L17.6207 19.1784L19.7407 21.6082C20.2576 22.1306 21.0955 22.1306 21.6124 21.6082C22.1292 21.0858 22.1292 20.2388 21.6124 19.7164H21.568L19.0134 17.6543Z"
      fill={props.fill || "#1E145D"}
    />
  </svg>
);
